import * as React from 'react';

const CardBrand = ({ imageUrl, name }) => {
  return (
    <div
      className="card-brand-box"
      style={{
        background: `url(${imageUrl}) lightgray 50% / contain no-repeat`,
      }}
      aria-label={name}
    />
  );
};

export default CardBrand;
